import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { popupOpenClose, setDeviceLoginPage } from '../../action/action'
import { popupColorSet } from '../../JS/setColors'
import GuestDeviceReg from '../../components/guest-device-registration/guestDeviceReg'
class GuestLoginPopup extends Component {
    onNoClick = () => {
        this.props.setDeviceLoginPage(false);
    }

    componentDidMount() {
        popupColorSet(this.props.menuColor);
    }
    render() {
        return (
            <div class="overlay">
                <GuestDeviceReg />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        notInHotelPopup: state.store.notInHotelPopup,
        popupMsg: state.store.popupMsg,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        popupOpenClose,
        setDeviceLoginPage
    }
)(GuestLoginPopup);